var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    stroke: "none",
    fill: "#3B4858",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7 19.1L0.275 10.7C0.175 10.6 0.104333 10.4917 0.063 10.375C0.021 10.2584 0 10.1334 0 10C0 9.86669 0.021 9.74169 0.063 9.62502C0.104333 9.50836 0.175 9.40002 0.275 9.30002L8.7 0.875024C8.93333 0.641691 9.225 0.525024 9.575 0.525024C9.925 0.525024 10.225 0.650024 10.475 0.900024C10.725 1.15002 10.85 1.44169 10.85 1.77502C10.85 2.10836 10.725 2.40002 10.475 2.65002L3.125 10L10.475 17.35C10.7083 17.5834 10.825 17.8707 10.825 18.212C10.825 18.554 10.7 18.85 10.45 19.1C10.2 19.35 9.90833 19.475 9.575 19.475C9.24167 19.475 8.95 19.35 8.7 19.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.719bf0a59be225a26914d66f18c952b7.svg";
export { ForwardRef as ReactComponent };